// TODO: consolidate translations (product-details, carousel.card, ....)
const product = {
  orderNow: 'Jetzt bestellen',
  detailsAndInfo: 'Details & Pflichtangaben',
  singlePrice: 'Einzelpreis',
  onlinePayment: 'Online payment',
  amount: 'Menge',
  total: 'Summe',
  tabs: {
    description: 'Beschreibung',
    reviews: 'Produktbewertungen',
    downloads: 'Downloads',
    ratings: 'Produktbewertungen',
  },
  pzn: 'PZN',
  manufacturer: 'Hersteller',
  brand: 'Marke',
  dosageForm: 'Darreichungsform',
  notes: 'Aufklärende Hinweise',
  offerer: 'Anbieter',
  packSize: 'Packungsgröße',
  basicPrice: 'Grundpreis',
  monopreparation: 'Monopräparat',
  contains: 'Enthält',
  activeIngredient: 'Wirkstoff',
  applicationAreas: 'Anwendungsgebiete',
  usageInstructions: 'Anwendungshinweise',
  operatingMode: 'Wirkungsweise',
  contraIndications: 'Gegenanzeigen',
  sideEffects: 'Nebenwirkungen',
  importantInstructions: 'Wichtige Hinweise',
  ingredients: 'Inhaltsstoffe',
  mandatoryInformation: 'Pflichtangaben',
  details: 'Details',
  volAlcohol: 'Vol.-% Alkohol.',
  gallery: {
    illustrationSimilar: 'Abbildung ähnlich',
    videoSupport: 'Your browser does not support the video tag.',
  },
  expressProduct: 'Express-Produkt',
  noOnlinePayment: 'Keine Online-Zahlung',
  prescription: 'Rezeptpflichtig',
  maximumAmountReached: {
    zeroInCart: 'Die maximale Bestellmenge für das Produkt wurde aus arzneimittelrechtlichen Gründen erreicht.',
    oneInCart: 'Dieses Produkt befindet sich bereits in Ihrem Warenkorb. Die maximale Bestellmenge für dieses Produkt wurde aus arzneimittelrechtlichen Gründen erreicht.',
    multipleInCart: 'Dieses Produkt befindet sich bereits mehrfach in Ihrem Warenkorb. Die maximale Bestellmenge für dieses Produkt wurde aus arzneimittelrechtlichen Gründen erreicht.',
  },
  rating: {
    averageRating: 'Durchschnittliche Bewertung',
    placeReview: 'Bewertung abgeben',
    noReviews: {
      title: 'Dieses Produkt hat noch keine Kundenbewertung erhalten',
      description: 'Sie haben dieses Produkt bereits verwendet? Helfen Sie anderen bei ihrer Entscheidungsfindung, indem Sie als erster Ihre Erfahrungen mit diesem Produkt teilen. ',
    },
    unknown: 'Unknown',
    alreadyRated: 'Sie haben dieses Produkt bereits bewertet. Eine weitere Bewertung ist nicht möglich.',
    form: {
      title: 'Dieses Produkt bewerten',
      from: 'von',
      overallRating: 'Gesamtbewertung *',
      package: 'Packungsgröße • ',
      nameHint: 'So werden Sie anderen Kunden angezeigt. Sie können auch eine Abkürzung wählen oder das Feld leer lassen.',
      terms: {
        1: 'Hiermit versichere ich, das bewertete Produkt tatsächlich erhalten zu haben, bzw. mich darum bemüht habe. Die Bewertung entspricht meiner persönlichen Erfahrung. Die',
        2: 'Nutzungsbedingungen',
        3: 'und',
        4: 'Datenschutzhinweise',
        5: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.',
      },
      mandatory: '* Bitte füllen Sie die Pflichtfelder aus',
      cancel: 'Abbrechen',
      send: 'Absenden',
      titleError: 'Bitte wählen Sie einen Titel',
      descriptionError: 'Bitte beschreiben Sie Ihre Erfahrungen',
      ratingError: 'Bitte geben Sie eine Gesamtbewertung ab',
      authorLabel: 'Ihr öffentlicher Name',
      titleLabel: 'Titel der Bewertung *',
      descriptionLabel: 'Fügen Sie eine Beschreibung hinzu *',
      note: 'Bitte beachten Sie: Es kann bis zu 24h dauern, bis Ihre Bewertung veröffentlicht wird.',
      thankYou: 'Vielen Dank für Ihre Bewertung. Sie haben {productName} mit {userRating} von 5 Sternen bewertet.',
    },
    cancelModal: {
      title: 'Möchten Sie Ihre Bewertung wirklich verwerfen?',
      description: 'Ihre Bewertung kann anderen Kunden bei der Kaufentscheidung helfen.',
      confirm: 'Ja, verwerfen',
      cancel: 'Nein',
    },
  },
  addItemInCart: 'Fügen Sie einen Artikel zum Warenkorb hinzu',
  removeItemFromCart: 'Entfernen Sie einen Artikel aus dem Warenkorb',
  productImage: 'Produktbild',
  couponDefaultText: 'Informationen zur Coupon-Aktion finden Sie {link}',
  couponTitle: 'Coupon-Informationen',
  couponLinkText: 'hier',
}

export default product
